import firebase from 'firebase/app';

export default class StrikePayoutModel {

  async startConnectingProviderIfNeeded(payout) {
    const db = firebase.firestore();

    const { status, clientId, uid } = payout || { };
    const entryStatus = 'validated';
    const newStatus = 'connecting';

    console.log('startConnectingProviderIfNeeded', status, clientId, uid);

    if (status && clientId && uid && status === entryStatus) {
      const ref = db
        .collection('clients')
        .doc(clientId)
        .collection('payouts')
        .doc(uid);

      await ref.update({
        status: newStatus,
        connectingAt: firebase.firestore.Timestamp.now(),
        updatedAt: firebase.firestore.Timestamp.now(),
      });
    }    

  }

  async retryPayoutSetup(payout) {
    const db = firebase.firestore();

    const { status, clientId, uid } = payout || { };

    console.log('retryPayoutSetup', status, clientId, uid);

    // For payouts in 'retry' status, reset to 'ready' to trigger another attempt
    if (status && clientId && uid && status === 'retry') {
      const ref = db
        .collection('clients')
        .doc(clientId)
        .collection('payouts')
        .doc(uid);

      await ref.update({
        status: 'ready',
        updatedAt: firebase.firestore.Timestamp.now(),
        // Clear error fields so fresh attempt is made
        lastErrorCode: firebase.firestore.FieldValue.delete(),
        lastErrorMessage: firebase.firestore.FieldValue.delete(),
        actionRequiredMessage: firebase.firestore.FieldValue.delete(),
        requiresAction: false,
        severity: firebase.firestore.FieldValue.delete(),
      });

      return { success: true };
    }

    return { success: false, message: 'Payout not in retry status' };
  }


}
